import { render } from "./TreeChildVersion2Component.vue?vue&type=template&id=2518f301"
import script from "./TreeChildVersion2Component.vue?vue&type=script&lang=js"
export * from "./TreeChildVersion2Component.vue?vue&type=script&lang=js"

import "./TreeChildVersion2Component.vue?vue&type=style&index=0&id=2518f301&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__